import { EntityStore } from '../../../shared/stores/EntityStore';
import { action, makeObservable } from 'mobx';
import { api } from '../../../shared/api/api';

class LocationStore extends EntityStore {
	constructor() {
		super('locations');
		makeObservable(this);
	}

	@action
	async getLocations(query) {
		const url = this.entityPluralEndpoint + '?q=' + query;

		return api.get(encodeURI(url));
	}
}

export const locationStore = new LocationStore();
